import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "file-info" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = {
  key: 0,
  class: "err-text"
}
const _hoisted_5 = {
  key: 1,
  class: "size"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Progressbar = _resolveComponent("Progressbar")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["download-progress", {error: $options.error, inline: $props.inline}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$slots.img)
        ? _renderSlot(_ctx.$slots, "img", {
            key: 0,
            instance: $props.instance,
            class: "file-icon"
          }, undefined, true)
        : (_openBlock(), _createBlock(_component_FileIcon, {
            key: 1,
            error: $options.error,
            ext: $options.ext,
            class: "file-icon"
          }, null, 8 /* PROPS */, ["error", "ext"])),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString($options.file.name), 1 /* TEXT */),
        ($options.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createTextVNode(" Upload failed")),
              ($options.error_detail)
                ? (_openBlock(), _createBlock(_component_Tooltip, {
                    key: 0,
                    text: $options.error_detail,
                    placement: "top",
                    class: "error-tooltip"
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("sup", {
                        style: {"font-weight":"700","margin-left":"0.1rem"},
                        class: "pointer"
                      }, "?", -1 /* HOISTED */)
                    ])),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["text"]))
                : _createCommentVNode("v-if", true),
              _cache[4] || (_cache[4] = _createTextVNode(", ")),
              _createElementVNode("b", {
                style: {"font-weight":"700"},
                class: "pointer",
                onClick: _cache[0] || (_cache[0] = $event => ($props.instance.start()))
              }, "try again"),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* HOISTED */))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($options.size), 1 /* TEXT */))
      ])
    ]),
    _createElementVNode("div", {
      class: "delete pointer",
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('delete', $props.instance.id)))
    }, [
      _withDirectives(_createVNode(_component_Icon, {
        width: "2rem",
        height: "2rem",
        icon: "trash-04",
        hoverable: "",
        stroke: "var(--gray-500)"
      }, null, 512 /* NEED_PATCH */), [
        [_vShow, !$options.error]
      ]),
      _withDirectives(_createVNode(_component_Icon, {
        width: "2rem",
        height: "2rem",
        icon: "trash-04",
        hoverable: "",
        stroke: "var(--error-600)"
      }, null, 512 /* NEED_PATCH */), [
        [_vShow, $options.error]
      ])
    ]),
    _createVNode(_component_Progressbar, {
      class: "progress",
      value: $options.progress,
      error: $options.error,
      success: $options.success
    }, null, 8 /* PROPS */, ["value", "error", "success"])
  ], 2 /* CLASS */))
}